import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MessagesTabs from '../../components/Messaging/MessagesTabs';
import EmptyState from '../../components/EmptyState';
import ModalShare from '../../components/Modal/ModalShare';
import './Messages.scss';
import { firestore, getPagingMessages } from '../../configs/environments/firebase/firebaseApp';
import { connect } from 'react-redux';
import * as ROUTES from '../../routes';

const marker = '/img/icons/destacado.svg';
const mintCircle = '/img/icons/mono-verde.svg';
const grayCircle = '/img/icons/mono-gray.svg';
const messageImg = '/img/empty-state/search.svg';

function Messages({ messageLaw, authClient, userUid, uid, membershipType, role }) {
  const [openModal, setOpenModal] = useState(false);
  const tabletSize = useMediaQuery('(max-width:768px)');

  const [arrayItems, setArrayItems]= useState([])
  const [page, setPage] = useState();
  const [totalPage, setTotalPage] = useState();

  useEffect(() => {
    fetchMyAPI();
  }, []);

  async function fetchMyAPI() {
    try {
      let messages = await getPagingMessages(uid, 1)
      let total = messages.totalPages;
      setArrayItems(messages.data)
      setTotalPage(total);
    } catch (error) {
      throw error;
    }
  }
  
  const handleChangePage = async (event, value) => {
    try {
      let messages = await getPagingMessages(uid, value);
      setArrayItems(messages.data)
    } catch (error) {
      throw error;
    }
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const link = `https://contactaabogado.com/${
    authClient.role === 'lawyer' ? 'abogado' : 'despacho'
  }/${authClient.uid}`;
 
  return (
    <div
      className="container"
      style={{ display: 'flex', flexFlow: 'column', width: '100%' }}
    >
      {membershipType === 'Free' ?
        (
          <EmptyState
            title={<span>La sección mensajes está disponible<br/>para usuarios Premium o Premium Plus</span>}
            subtitle={<span>Al adquirir una membresía podrás posicionarte mejor en los rankings<br/>de búsqueda de tu ciudad, ¡actívala ahora!</span>}
            img={messageImg}
            direction={ROUTES.MEMBERSHIPS_LAWYERS}
            handleClick={() => console.log('Ver las membresías')}
            callToAction="Ver membresías"
          />
        ) :
      arrayItems && arrayItems.length > 0 ? (
        <div style={{ margin: '0 auto', maxWidth: '100%' }}>
          {/* <MainTitle
          title="Mensajes"
          subtitle="En este panel podrás tener gestión de los mensajes que recibes en la plataforma"
        >  */}
          <div style={tabletSize ? { padding: '0 24px' } : null}>
            <p className="messages-title">Mensajes</p>
            <p className="messages-subtitle">
              En este panel podrás tener gestión de los mensajes que recibes en
              la plataforma.
            </p>
          </div>

          <div style={{ display: 'flex', margin: '24px 0' }}>
            <MessagesTabs
              dataRef={arrayItems}
              userUid={userUid}
              handleChangePage={handleChangePage}
              page={page}
              totalPage={totalPage}
            />

            <div
              className="messages-instructions"
              style={isMobile ? { display: 'none' } : null}
            >
              <div className="messages-instructions-title">
                <p>Instrucciones</p>
              </div>
              <div style={{ padding: '23px 32px 0 16px' }}>
                <div className="messages-instructions-contacts">
                  <p>Agrega a tus contactos</p>
                  <div style={{ display: 'flex' }}>
                    <img
                      src={marker}
                      alt="icono destacado"
                      width="24px"
                      height="24px"
                      style={{ marginRight: 8 }}
                    />
                    <p>
                      Marcando este icono, usted puede clasificar los mensajes
                      de clientes potenciales, agregándolos como parte de su directorio,
                      desde ahí podrá encontrar rápidamente los datos del cliente,
                      así como desmarcarlos si ya no quiere ese mensaje.
                    </p>
                  </div>
                </div>
                <div className="messages-instructions-class">
                  <p>Clasificación</p>
                  <p>
                    Puede identificar los mensajes provenientes de usuarios
                    registrados y los que no, en nuestra plataforma
                  </p>
                  <div>
                    <div className="user-green">
                      <img
                        src={mintCircle}
                        className="user-green-circle"
                        alt="indicador menta"
                      />
                      <div className="user-green-text">
                        <p>
                          Los mensajes de color verde clasifican a los usuarios
                          registrados.{' '}
                        </p>
                      </div>
                    </div>
                    <div className="user-gray">
                      <img
                        src={grayCircle}
                        className="user-gray-circle"
                        alt="indicador gris"
                      />
                      <div className="user-gray-text">
                        <p>
                          Los mensajes marcados con color gris son personas que
                          no estan registradas en nuestra plataforma pero pueden
                          tener contacto contigo.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </MainTitle> */}
        </div>
      ) : (
        <>
          <EmptyState
            title={<span>Pronto te llegarán mensajes <br/>de clientes potenciales</span>}
            subtitle={<span>Pero no te quedes esperando, comienza dando clic en el botón <br/>de abajo para compartir tu perfil con clientes y conocidos</span>}
            img={messageImg}
            handleClick={() => setOpenModal(true)}
            callToAction="Comparte tu perfil"
          />
          <ModalShare
            open={openModal}
            link={link}
            isSocial={true}
            handleClose={handleClose}
          />
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  membershipType: state.authClient.membership.type,
  messageLaw: state.authClient.messageLaw,
  authClient: state.authClient,
  role: state.authClient.role,
  uid: state.authClient.uid,
});

export default connect(mapStateToProps)(Messages);